$(document).ready(function() {

    // MENU

    $(document).on('click', '.js-menu-toggle', function(e) {
        e.preventDefault();
        $(this).toggleClass('c-header__hamburger--active');
        $('.js-menu').toggleClass('c-header__main-menu-container--active');

        if ($(this).hasClass('c-header__hamburger--active')) {
            $('body').addClass('u-no-scroll');
        } else {
            $('body').removeClass('u-no-scroll');
        }
    });

    // mobile menu close - contact button
    const mobileMenuButtons = ['.o-button--mobile-contact', '.o-button-projects--mobile-contact'];

    mobileMenuButtons.forEach((btnClass)=> {
        $(document).on('click',btnClass,function (){
            $('body').removeClass('u-no-scroll');
            $('.c-header__hamburger').removeClass('c-header__hamburger--active');
            $('.js-menu').removeClass('c-header__main-menu-container--active');
        })
    })

    // HP CAROUSEL

    if($('.js-carousel-content').length) {
        $('.js-carousel-content').slick({
            speed: 300,
            autoplay: true,
            autoplaySpeed: 7000,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '<button class="slide-arrow prev-arrow"></button>',
            nextArrow: '<button class="slide-arrow next-arrow"></button>',
            appendArrows: $('.c-carousel__content'),
            infinite: true,
            // adaptiveHeight: true,
            swipe: true,
            pauseOnHover: false
        });
        setTimeout(function(){
            $('.js-carousel').addClass('c-carousel--active');
        },100);

    }

    // LANGUAGE MENU

    $(window).click(function() {
        $('.js-language-menu').removeClass('c-header__language-container--active');
    });

    $(document).on('click', '.js-language-menu', function(e) {
        e.stopPropagation();
        $(this).toggleClass('c-header__language-container--active');
    });

    // Active navigation
    const navLinks = Array.from(document.querySelectorAll('.js-main-menu a'))
    const activeUrl = window.location.href
    navLinks.forEach((link) => {
        activeUrl.includes(link.href) ? link.classList.add('active-link') : ''
    })

    // CONTACT MENU BUTTON
    const contactBtn = document.querySelector('.c-header__contact-menu--mobile a');
    if (contactBtn) {
        contactBtn.classList.add('o-button', 'o-button--mobile-contact');
    }

    const contactBtnProjects = document.querySelector('.c-header__contact-menu-projects--mobile a');
    if (contactBtnProjects) {
        contactBtnProjects.classList.add('o-button-projects', 'o-button-projects--mobile-contact');

        if (location.href.includes('tri-dvory-ujezd-u-brna')) {
            contactBtnProjects.classList.add('o-button-projects--brown');
        }
    }

        // VIDEO HANDLER
    $(document).on('click', '.js-community-dev-play', function(e) {
        $('.js-community-dev-video').addClass('c-community-dev-intro__video--visible');
        $('.js-community-dev-video').trigger('play').prop('controls', 'true');
        $(this).fadeOut();
    });

    /* LIGHTGALLERY */

    const projectGallery = Array.from(document.querySelectorAll('.c-gallery .wp-block-image'));

    if (projectGallery.length) {

        const hideImages = projectGallery.filter((_, i) => i >= 5);
        hideImages.forEach((image)=> image.style.display = "none")

        $(".c-gallery figure").each(function() {
            $(this).attr("href", $(this).find("a").attr("href"));
        });

        if ($(".blocks-gallery-grid").length > 0) {
            $(".blocks-gallery-grid").lightGallery();
        } else {
            $(".wp-block-gallery").lightGallery();
        }

        const galleryButton = document.createElement('div');
        galleryButton.classList.add('o-button', 'o-button--arrow', 'o-button--white-soft', 'o-button--white-soft--arrow','last-image');
        galleryButton.innerHTML = `GALERIE (${projectGallery.length})`;
        const lastImage = document.querySelector('.wp-block-image:nth-of-type(5) a');
        if (lastImage) {
            lastImage.appendChild(galleryButton)
        }
    }

    /* FORM */
    /* radio */
    const radioButtons = Array.from(document.querySelectorAll('input[type=radio]'));

    const activeState = function () {
        radioButtons.forEach( radio => {
            radio.classList.remove('active');
            radio.nextElementSibling.classList.remove('active');
            radio.parentElement.classList.remove('active');
        })
        this.classList.add('active');
        this.nextElementSibling.classList.add('active');
        this.parentElement.classList.add('active');
    }

    radioButtons.forEach( radio => {
        radio.addEventListener('click', activeState);
    })

    const activeOnLoad = function (element) {
        element.checked = true;
        element.classList.add('active');
        element.nextElementSibling.classList.add('active');
        element.parentElement.classList.add('active');
    }

    const locHref = window.location.href;

    if (locHref.includes('/o-nas/') || locHref.includes('/pro-investory/') || locHref.includes('/projekty/')) {
        activeOnLoad(radioButtons[2]);
    } else if(locHref.includes('/financovani/')){
        activeOnLoad(radioButtons[1]);
    } else {
        activeOnLoad(radioButtons[0]);
    }

    /* homepage spolupracujte s nami */
    const wantSell = document.querySelector('#want-sell');
    if (wantSell) {
        wantSell.addEventListener('click', () => {
            radioButtons.forEach( radio => {
                radio.classList.remove('active');
                radio.nextElementSibling.classList.remove('active');
                radio.parentElement.classList.remove('active');
            })
            activeOnLoad(radioButtons[3]);
        })
    }

    /* checkboxes */
    const checkboxes = Array.from(document.querySelectorAll('input[type=checkbox]'));

    checkboxes.forEach(box => {
        box.addEventListener('click', function () {
            this.parentElement.classList.toggle('checked');
        })
    })

    /* Input text focus */
    const inputElements = Array.from(document.querySelectorAll('input[type=text], input[type=tel], input[type=email], .wpcf7-textarea'));

    inputElements.forEach(input => {
        input.addEventListener('focus', function () {
            this.classList.add('active');
            this.parentElement.previousElementSibling.classList.add('active');
        })
        input.addEventListener('blur', function () {
            if (!input.value) {
                this.classList.remove('active');
                this.parentElement.previousElementSibling.classList.remove('active');
            }
        })
        input.addEventListener('input', function () {
            if (input.value !== '') {
                this.classList.add('active');
                this.parentElement.previousElementSibling.classList.add('active');
            }
        })
    })

    function formatNumberWithSpaces(numberAsString) {
        let numberString = numberAsString.replace(/\s/g, '');
        numberString = numberString.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        return numberString;
    }


    /* input number + - */
    const downs = Array.from(document.querySelectorAll(".down-number"));
    const ups = Array.from(document.querySelectorAll(".up-number"));

    downs.forEach((down) => {
        down.addEventListener("click", function () {
            this.previousElementSibling.children[0].stepDown();
            this.nextElementSibling.nextElementSibling.style.left = 68 + (this.previousElementSibling.children[0].value.length * 7.5) + 'px'
        });
    });

    ups.forEach((up) => {
        up.addEventListener("click", function () {
            this.previousElementSibling.previousElementSibling.children[0].stepUp();
            this.nextElementSibling.style.left = 68 + (this.previousElementSibling.previousElementSibling.children[0].value.length * 7.5) + 'px'
        });
    });

    /* input string + - */
    const valueStep = 100000;
    const downsString = Array.from(document.querySelectorAll(".down-string"));
    const upsString = Array.from(document.querySelectorAll(".up-string"));

    downsString.forEach((down) => {
        down.addEventListener("click", function () {
            this.previousElementSibling.children[0].value = Number(this.previousElementSibling.children[0].value.replaceAll(' ', '')) - valueStep;
            this.previousElementSibling.children[0].value = formatNumberWithSpaces(this.previousElementSibling.children[0].value);
            this.nextElementSibling.nextElementSibling.style.left = 68 + (this.previousElementSibling.children[0].value.length * 7.5) + 'px'
        });
    });

    upsString.forEach((up) => {
        up.addEventListener("click", function () {
            this.previousElementSibling.previousElementSibling.children[0].value = Number(this.previousElementSibling.previousElementSibling.children[0].value.replaceAll(' ', '')) + valueStep;
            this.previousElementSibling.previousElementSibling.children[0].value = formatNumberWithSpaces(this.previousElementSibling.previousElementSibling.children[0].value);
            this.nextElementSibling.style.left = 68 + (this.previousElementSibling.previousElementSibling.children[0].value.length * 7.5) + 'px'
        });
    });

    /* hypoteka form functions */
    const hypoForm = document.querySelector('#hypoteka-form');

    if (hypoForm) {
        const formElement = hypoForm.parentElement;
        const hypoThankYou = document.querySelector('#hypoteka-thank-you');
        const hypoThankYouBtn = document.querySelector('#hypoteka-thank-you a');
        const responseForm = document.querySelector('.wpcf7-response-output');

        const priceInput = Array.from(document.getElementsByName('price'));
        const loanInput = Array.from(document.getElementsByName('loan'));
        const fixationInput = Array.from(document.getElementsByName('fixation'));
        const repaymentInput = Array.from(document.getElementsByName('repayment'));
        const inputsChangeArr = [priceInput,loanInput,fixationInput,repaymentInput].flat();

        inputsChangeArr.forEach(input => {
            input.addEventListener('input', function () {
                const units = this.parentElement.nextElementSibling.nextElementSibling.nextElementSibling;
                input.value = formatNumberWithSpaces(input.value);
                units.style.left = 68 + (input.value.length * 8) + 'px'
            })
        })


        formElement.addEventListener('wpcf7mailsent', () => {
            hypoThankYou.classList.remove('hidden');
            hypoForm.classList.add('hidden');
            responseForm.style.display = "none";
        })

        hypoThankYouBtn.addEventListener('click', () => {
            hypoThankYou.classList.add('hidden');
            hypoForm.classList.remove('hidden');
            formElement.reset();
            checkboxes.forEach(box => {
                box.parentElement.classList.remove('checked');
            })
        })
    }

    /* TABLE PROJECTS RESERVED FLATS */
    const tableBodyRows = Array.from(document.querySelectorAll('.c-sale-table__table tbody tr'));

    if (tableBodyRows.length > 0) {
        const reservedRows = tableBodyRows.filter(row => row.lastElementChild.innerHTML === "ano");

        reservedRows.forEach(row => {
            row.classList.add('reserved');
        })

    }

});
